import { render, staticRenderFns } from "./NewsSearchModal.vue?vue&type=template&id=404d5ac3"
import script from "./NewsSearchModal.vue?vue&type=script&lang=js"
export * from "./NewsSearchModal.vue?vue&type=script&lang=js"
import style0 from "./NewsSearchModal.vue?vue&type=style&index=0&id=404d5ac3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports